import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import getHasCurrentOrders from '#app/api/get-has-current-orders'
import shouldMatchRole from '#app/guards/should-match-role'
import router from '#app/router'
import { Loading } from '#pages/common/loading'
import { SomethingWentWrong } from '#pages/common/something-went-wrong'
import { ModalsLayout } from '#widgets/layouts/modals-layout'
import { NotificationsLayout } from '#widgets/layouts/notifications-layout'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'
import { combinePaths } from '#shared/lib/strings'

export const Route = createFileRoute('/client')({
  component: () => (
    <ModalsLayout>
      <NotificationsLayout>
        <Outlet />
      </NotificationsLayout>
    </ModalsLayout>
  ),

  loader: async () => {
    await shouldMatchRole('client')

    const roleInfo = getCurrentUserRoleInfo()

    const currentPathname = router.state.location.pathname

    // Make redirects only if current path is /client
    if (currentPathname !== combinePaths(router.basepath, '/client')) {
      return
    }

    if (roleInfo.isGiven) {
      // If client has current orders, redirecting to orders
      const hasCurrentOrders = await getHasCurrentOrders()
      if (hasCurrentOrders) {
        throw redirect({ to: '/client/orders' })
      }

      // Default post-registered client page
      throw redirect({ to: '/client/new-order', search: { selectedServices: [], tab: 'ROUTINE' } })
    }

    // Default pre-registered client page
    throw redirect({ to: '/client/profile' })
  },

  errorComponent: () => <SomethingWentWrong withHardReload />,

  pendingComponent: () => <Loading />,
})
